document.addEventListener("DOMContentLoaded", () => {
  if (customElements.get("p-sale-swiper")) return;

  class PSaleSwiper extends HTMLElement {
    constructor() {
      super();
      this.$this = $(this);
      this.childSwiperInstances = [];
      this.childPcEnableSwiper = this.$this.data("child-pc-enable-swiper");
      this.childMbEnableSwiper = this.$this.data("child-mb-enable-swiper");
      this.childPcSlides = this.$this.data("child-pc-slides");
      this.childMbSlides = this.$this.data("child-mb-slides");
      this.childPcGap = this.$this.data("child-pc-gap");
      this.childMbGap = this.$this.data("child-mb-gap");
      this.childShowPagination = this.$this.data("child-show-pagination");
      this.childShowNavigation = this.$this.data("child-show-navigation");
      this.childEnableSlidesOffset = this.$this.data("child-slides-offset");
      const childAutoMobileOffset = this.$this.data("child-auto-mobile-offset");
      this.childAutoMobileOffset = childAutoMobileOffset !== false && childAutoMobileOffset !== "false";
      this.childEnableLoop = this.$this.data("child-loop") === true || this.$this.data("child-loop") === "true";
      this.$groupSwiperContainer = this.$this.find(".p-sale-swiper-groups-container");
      this.$groupNamesWrapper = this.$this.find(".p-sale-swiper-groups-names-wrapper");
      this.$fixedProductContainer = this.$this.find(".p-sale-swiper-fixed-product-container");
      this.$variantsSelector = this.$this.find(".p-variant-selector");

      this.handleGroupChange = this.handleGroupChange.bind(this);
    }

    connectedCallback() {
      this.initFixedProduct();
      this.initGroupSwiper();
      this.initChildSwiper();
      this.initVariantSelector();
      this.initDiscountCodeCopy();
      let resizeTimer = null;
      const self = this;
      let lastWidth = visualViewport.width;
      $(window).on("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          const currentWidth = visualViewport.width;
          if (currentWidth === lastWidth) return;
          self.rebuildSwipers();
          self.updateSwiper();
          lastWidth = currentWidth;
        }, 200);
      });
    }

    updateSwiper() {
      if (Array.isArray(this.childSwiperInstances) && this.childSwiperInstances.length > 0) {
        this.childSwiperInstances.forEach((instance) => {
          instance.update();
        });
      }
      setTimeout(() => {
        if (this.groupSwiperInstance) {
          this.groupSwiperInstance.update();
        }
      }, 0);
    }

    disconnectedCallback() {
      this.$variantsSelector.off(".pSaleVariantSelector");
      this.$this.off(".pSaleDiscountCode");
      this.destroySwipers();
    }

    initFixedProduct() {
      if (this.$fixedProductContainer.length > 0) {
        this.$fixedProductContainer.each((_, container) => {
          const $container = $(container);

          const $targets = $container.parent().find(".p-sale-swiper-fixed-product");

          $container.append($targets);
        });
      }
    }

    initGroupSwiper() {
      if (this.$groupNamesWrapper.length > 0 && this.$groupSwiperContainer.length > 0) {
        const params = {
          slidesPerView: 1,
          allowTouchMove: false,
          spaceBetween: 10,
          autoHeight: true,
        };
        this.groupSwiperInstance = new Swiper(this.$groupSwiperContainer[0], params);
        this.initGroupSwiperNameEvent();
      }
    }

    initGroupSwiperNameEvent() {
      if (this.$groupNamesWrapper.length > 0 && this.groupSwiperInstance) {
        const self = this;
        this.handleGroupChange(0);
        this.$groupNamesWrapper.on("click", ".p-sale-swiper-group-name", function () {
          const index = $(this).data("index");
          self.handleGroupChange(index);
        });
      }
    }

    // 轮播数量不足以超出一屏时，隐藏分页/箭头（即使后台开了 Show Pagination / Navigation）
    setChildControlsVisible($group, visible) {
      const $pagination = $group.find(".swiper-pagination");
      const $buttons = $group.find(".p-sale-bundle-swiper-buttons-container");
      $pagination.css("display", visible ? "" : "none");
      $buttons.css("display", visible ? "" : "none");
    }

    initChildSwiper() {
      const $container = this.$this.find(".p-sale-swiper-children-container");
      const isDesktop = visualViewport.width > 850;

      $container.each((i, childrenContainer) => {
        const $childrenContainer = $(childrenContainer);
        const $group = $childrenContainer.parent();
        const $groupContainer = $childrenContainer.closest(".p-sale-swiper-group-container");
        const $wrapper = $childrenContainer.find(".p-sale-swiper-children-wrapper");
        const groupMobileSwiper = $groupContainer.attr("data-mb-enable-swiper");
        const groupMobileSlides = Number($groupContainer.attr("data-mb-slides"));
        const groupMobileSize = Number($groupContainer.attr("data-mb-group-size"));
        const enableSwiper = isDesktop
          ? this.childPcEnableSwiper
          : groupMobileSwiper === undefined
            ? this.childMbEnableSwiper
            : groupMobileSwiper === "true";

        this.restoreMobileFeaturedProduct($childrenContainer, $wrapper);
        this.restoreChildSlideGroups($wrapper);

        if (!isDesktop) this.fixMobileFeaturedProduct($childrenContainer, $wrapper);

        if (!isDesktop && enableSwiper && Number.isFinite(groupMobileSize) && groupMobileSize > 1) {
          this.groupChildSlides($wrapper, groupMobileSize);
        }

        const $items = $wrapper.children(".p-sale-swiper-children-product-item, .p-sale-swiper-child-group");

        if (!enableSwiper) {
          $childrenContainer.removeClass("swiper-container");
          $wrapper.removeClass("swiper-wrapper");
          $items
            .removeClass("swiper-slide swiper-slide-active swiper-slide-next swiper-slide-prev")
            .removeAttr("style");
          this.setChildControlsVisible($group, false);
          return;
        }

        $childrenContainer.addClass("swiper-container");
        $wrapper.addClass("swiper-wrapper");
        $items.addClass("swiper-slide");

        const itemCount = $items.length;
        const groupPcSlides = Number($groupContainer.attr("data-pc-slides"));
        const pcSlides = Number.isFinite(groupPcSlides) && groupPcSlides > 0 ? groupPcSlides : this.childPcSlides;
        const mobileSlides =
          Number.isFinite(groupMobileSlides) && groupMobileSlides > 0 ? groupMobileSlides : this.childMbSlides;
        const slidesPerView = isDesktop ? pcSlides : mobileSlides;
        const needsControls = slidesPerView < itemCount;
        this.setChildControlsVisible($group, needsControls);

        const params = isDesktop
          ? {
              slidesPerView: pcSlides,
              spaceBetween: this.childPcGap,
              allowTouchMove: this.childEnableSlidesOffset ? true : needsControls,
              loop: this.childEnableLoop,
            }
          : {
              slidesPerView: mobileSlides,
              spaceBetween: this.childMbGap,
              allowTouchMove: this.childEnableSlidesOffset ? true : needsControls,
              loop: this.childEnableLoop,
            };

        const useMobileOffset = !isDesktop && this.childAutoMobileOffset && !$groupContainer.is("[data-mb-slides]");
        if (this.childEnableSlidesOffset || useMobileOffset) {
          const offsetValue = this.getSwiperOffset();
          params.slidesOffsetBefore = offsetValue;
          if (!isDesktop) params.slidesOffsetAfter = offsetValue;
          params.watchOverflow = false;
        }
        if (this.childShowPagination && needsControls) {
          params.pagination = {
            el: $group.find(".swiper-pagination")[0],
            clickable: true,
            type: "bullets",
          };
        }
        if (this.childShowNavigation && needsControls) {
          const $buttons = $group.find(".p-sale-bundle-swiper-buttons-container");
          params.navigation = {
            nextEl: $buttons.find(".swiper-button-next")[0],
            prevEl: $buttons.find(".swiper-button-prev")[0],
          };
        }
        this.childSwiperInstances[i] = new Swiper(childrenContainer, params);
      });
    }

    restoreChildSlideGroups($wrapper) {
      $wrapper.children(".p-sale-swiper-child-group").each((_, group) => {
        const $group = $(group);
        $group.children(".p-sale-swiper-children-product-item").insertBefore($group);
        $group.remove();
      });
    }

    restoreMobileFeaturedProduct($childrenContainer, $wrapper) {
      const $featured = $childrenContainer
        .find(".p-sale-swiper-fixed-product-container > .bf-26-rv-mobile-featured")
        .first();

      if ($featured.length) $wrapper.prepend($featured);
    }

    fixMobileFeaturedProduct($childrenContainer, $wrapper) {
      const $featured = $wrapper.children(".bf-26-rv-mobile-featured").first();
      const $fixedContainer = $childrenContainer.children(".p-sale-swiper-fixed-product-container");

      if ($featured.length && $fixedContainer.length) $fixedContainer.append($featured);
    }

    groupChildSlides($wrapper, groupSize) {
      const cards = $wrapper.children(".p-sale-swiper-children-product-item").toArray();

      cards.forEach((card) => {
        $(card).removeClass("swiper-slide swiper-slide-active swiper-slide-next swiper-slide-prev").removeAttr("style");
      });

      for (let index = 0; index < cards.length; index += groupSize) {
        const $group = $('<div class="p-sale-swiper-child-group"></div>');
        cards.slice(index, index + groupSize).forEach((card) => $group.append(card));
        $wrapper.append($group);
      }
    }

    initVariantSelector() {
      if (this.$variantsSelector.length === 0) return;

      const eventName = "change.pSaleVariantSelector";

      this.$variantsSelector.off(eventName, "select");
      this.$variantsSelector.on(eventName, "select", (event) => {
        const select = event.currentTarget;
        const selectedOption = select.options[select.selectedIndex];
        const variantData = selectedOption?.getAttribute("data-variant");

        if (!variantData) return;

        let variant;
        try {
          variant = JSON.parse(variantData);
        } catch (error) {
          console.error("Invalid variant data in p-sale-product-card", error);
          return;
        }

        const $selector = $(select).closest(".p-variant-selector");
        const $card = $selector.closest(".p-sale-product-card");
        if ($card.length === 0) return;

        const price = Number(variant.price) || 0;
        const compareAtPrice = Number(variant.compareAtPrice) || 0;
        const variantId = Number(variant.id);
        const isAvailable = variant.available !== false;
        const formatMoney = (amount) => {
          if (window.theme?.Currency?.formatMoney) {
            return window.theme.Currency.formatMoney(amount, window.theme.strings?.moneyFormat);
          }

          return `$${(amount / 100).toFixed(2)}`;
        };
        const updatePrice = ($price, formattedPrice, amount) => {
          if ($price.length === 0) return;

          const priceText = formattedPrice || formatMoney(amount);
          const priceParts = priceText.match(/^(.*?)([.,]\d{2})$/);

          $price.attr("content", (amount / 100).toFixed(2));
          $price.find(".price-int").text(priceParts ? priceParts[1] : priceText);
          $price.find(".price-dec").text(priceParts ? priceParts[2] : "");
        };

        $selector.find(".p-variant-selector-value").text(variant.title || selectedOption.textContent.trim());

        const $priceBox = $card.find(".product-price-box").first();
        updatePrice($priceBox.find(".on-sale").first(), variant.formattedPrice, price);

        const $compareAtPrice = $priceBox.find(".compare-at").first();
        const hasCompareAtPrice = compareAtPrice > price;
        $compareAtPrice
          .text(hasCompareAtPrice ? variant.formattedCompareAtPrice || formatMoney(compareAtPrice) : "")
          .prop("hidden", !hasCompareAtPrice);

        const discountContent = variant.discountContent || "";
        const $discountContent = $card.find(".p-sale-product-card-discount-content").first();
        $discountContent.text(discountContent);
        $discountContent.closest(".p-sale-product-card-discount-container").prop("hidden", !discountContent);

        const $buttonBox = $card.find(".product-link-box").first();
        const $buyNowButton = $buttonBox.find(".quick-buynow-btn").first();
        const availableText = $buyNowButton.attr("data-available-text");
        const soldOutText = $buyNowButton.attr("data-sold-out-text");

        $buttonBox.toggleClass("has-sold-out", !isAvailable);
        $buyNowButton
          .attr("data-id", variantId)
          .prop("disabled", !isAvailable)
          .attr("aria-disabled", String(!isAvailable));

        if (availableText && soldOutText) {
          $buyNowButton.text(isAvailable ? availableText : soldOutText);
        }

        const $addToCart = $buttonBox.find("multi-add-cart-button").first();
        $addToCart.attr(
          "data-products",
          JSON.stringify([{ variantId, quantity: 1, handle: variant.handle || $card.attr("data-product-handle") }]),
        );
        $addToCart.find("button").prop("disabled", !isAvailable).attr("aria-disabled", String(!isAvailable));

        const productInfo = $card.data("product-info") || {};
        const updatedProductInfo = {
          ...productInfo,
          variants: [
            {
              variantId,
              price,
              compareAtPrice: compareAtPrice || price,
            },
          ],
        };

        $card.attr("data-product-info", JSON.stringify(updatedProductInfo));
        $card.data("product-info", updatedProductInfo);
      });
    }

    initDiscountCodeCopy() {
      this.$this.off("click.pSaleDiscountCode", ".p-sale-product-card-product-discount-code button");
      this.$this.on("click.pSaleDiscountCode", ".p-sale-product-card-product-discount-code button", async (event) => {
        const discountCode = event.currentTarget.dataset.discountCode;
        if (!discountCode || !navigator.clipboard) return;

        try {
          await navigator.clipboard.writeText(discountCode);
          event.currentTarget.textContent = "Copied";
        } catch (error) {
          console.error("Unable to copy discount code", error);
        }
      });
    }

    destroySwipers() {
      if (this.groupSwiperInstance && !this.groupSwiperInstance.destroyed) {
        this.groupSwiperInstance.off("slideChange.fixed");
        this.groupSwiperInstance.destroy(true, true);
        this.groupSwiperInstance = null;
      }
      if (Array.isArray(this.childSwiperInstances) && this.childSwiperInstances.length > 0) {
        this.childSwiperInstances.forEach((instance) => {
          instance.off("slideChange.fixed");
          instance.destroy(true, true);
          instance = null;
        });
        this.childSwiperInstances = [];
      }
    }

    rebuildSwipers() {
      this.destroySwipers();
      this.initGroupSwiper();
      this.initChildSwiper();
    }

    handleGroupChange(index) {
      this.groupSwiperInstance.slideTo(index);

      const $items = this.$groupNamesWrapper.find(".p-sale-swiper-group-name");
      const $active = $items.removeClass("is-active").eq(index).addClass("is-active");

      const container = this.$groupNamesWrapper.parent()[0]; // container
      const item = $active[0];

      if (!container || !item) return;

      const containerWidth = container.clientWidth;
      const itemLeft = item.offsetLeft;
      const itemWidth = item.offsetWidth;

      const target = itemLeft - containerWidth / 2 + itemWidth / 2;

      const maxScroll = container.scrollWidth - containerWidth;
      const finalScroll = Math.max(0, Math.min(target, maxScroll));

      container.scrollTo({
        left: finalScroll,
        behavior: "smooth",
      });
    }

    getSwiperOffset() {
      const cssOffset = getComputedStyle(document.documentElement)
        .getPropertyValue("--p-common-wrapper-half-padding")
        .trim();
      const el = document.createElement("div");
      el.style.position = "absolute";
      el.style.visibility = "hidden";
      el.style.pointerEvents = "none";
      el.style.width = `${cssOffset}`;

      document.body.appendChild(el);
      const value = el.getBoundingClientRect().width;
      document.body.removeChild(el);

      return value;
    }
  }

  customElements.define("p-sale-swiper", PSaleSwiper);
});
